export function QLookupObj() {}
